import React from "react";
import { useBnbSelector } from "../../../redux/store";
import { BnbLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as MotorizationStyles from "./styles/Motorization";
import FinanceToggle from "../common/FinanceToggle";
import Motorization from "./Motorization";
import Container from "../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import { useBreakpoint } from "../../../../../../common-deprecated/themes/common";

const Engines = (): JSX.Element => {
    const motorizations = useBnbSelector((state) => state.grade.motorizations);
    const modelCode = useBnbSelector((state) => state.grade.model.code);
    const gradeHasMultipleEngines = motorizations.length > 1;

    const isMobile = useBreakpoint("down", "sm");

    return (
        <Container>
            <Flex.Row mb={{ xs: 3, lg: 5 }}>
                <Flex.Col display="flex" alignItems="center" width={{ _: 1, md: "auto" }}>
                    <MotorizationStyles.Title>
                        <BnbLabel
                            label={gradeHasMultipleEngines ? "chooseYourEngine" : "thisIsYourEngine"}
                            fallbackLabel="chooseYourEngine"
                        />
                    </MotorizationStyles.Title>
                </Flex.Col>
                <Flex.Col display="flex" alignItems="flex-start" width={{ _: 1, md: "auto" }} ml={{ _: 0, md: "auto" }}>
                    <FinanceToggle modelCode={modelCode} isFullWidth={isMobile} />
                </Flex.Col>
            </Flex.Row>
            <Flex.Row>
                {motorizations.map((motorization) => (
                    <Flex.Col width={{ xs: 1, md: 1 / 2 }} key={motorization.carID}>
                        <Motorization motorization={motorization} gradeHasMultipleEngines={gradeHasMultipleEngines} />
                    </Flex.Col>
                ))}
            </Flex.Row>
        </Container>
    );
};

export default Engines;
